<template>
	<div class="content-wrapper">
			<div v-if="componentLoader" class="position-relative h-100">
				<app-overlay-loader />
			</div>
			<div v-else>
				<app-overlay-loader v-if="preloader" />
				<parent-profile-tab-children-info-table :parentId="value.id" />
			</div>
		</div>
</template>

<script>
import GlobalHelperMixin from "../../../../../Mixins/global/GlobalHelperMixin";
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin";
import { UserMixin } from "../../../Auth/Mixins/UserMixin";
import * as actions from "../../../../../Config/ApiUrl";
import AppLibrary from "../../../../../Helpers/AppLibrary";
import { urlGenerator } from "../../../../../Helpers/AxiosHelper";

export default {
	name: "ChildrenInfo",
	extends: AppLibrary,
	mixins: [FormMixin, UserMixin, GlobalHelperMixin],
	props: {
		value: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	data() {
		return {
			preloader: false,
		};
	},
};
</script>
